module.exports = __webpack_public_path__ + "media/images/flags/64/Tunisia-3b3d91a757fc073a5117f4067b14c8cf.png";